import { useParams } from 'react-router-dom';
import { Skeleton } from 'antd';
import { useState } from 'react';
import { Button, Row } from 'react-bootstrap';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { useForm } from 'react-hook-form';
import fireApp, { writersCollectionRef } from '../../firebase/fire-app';
import { useEffect } from 'react';


const EditWriter = () => {
    const { writerId } = useParams();
    const { register, handleSubmit, watch, errors } = useForm();
    const [writerData, loading, error] = useDocumentData(writersCollectionRef.doc(writerId), { idField: "id" });
    const [userImg, setUserImg] = useState(null)
    const onWriterAdded = (data, e) => {
        const writerName = data.name.toLowerCase();
        data.userName = writerName.replace(/ /g, "-");
        data.img = userImg ? userImg : null;
        writersCollectionRef.doc(writerId).set(data).then(() => {
            alert(`Updated info of ${data.name}`)
        })
    }
    const onUserImgUploaded = (e) => {
        let storageRef = fireApp.storage().ref();
        let blogStorage = storageRef.child(`writers/${writerId}`);
        const imgFile = e.target.files[0];
        blogStorage
            .put(imgFile).then((snapshot) => {
                snapshot.ref.getDownloadURL().then(res => {
                    setUserImg(res);
                })
            })
    }
    useEffect(() => {
        if (writerData && writerData.img) {
            setUserImg(writerData.img);
        }

    }, [writerData])
    return (
        <>
            <h4 className="font-weight-bold">Edit: {writerId} </h4>
            <section className="bg-white">
                <div className="container-fluid">
                    {loading && <Skeleton />}
                    {writerData && <form className="p-5" onSubmit={handleSubmit(onWriterAdded)}>

                        <Row>
                            <InputWrapper col={5} label="Full Name" >
                                <input {...register("name")} defaultValue={writerData.name} type="text" name="name" className="form-control" placeholder="Sundar Pichai" />
                            </InputWrapper>
                            <InputWrapper col={7} label="Title">
                                <input {...register("title")} defaultValue={writerData.title} type="text" name="title" className="form-control" placeholder="CEO, Google" />
                            </InputWrapper>
                            <InputWrapper col={12} label="Description">
                                <input {...register("description")} defaultValue={writerData.description} type="text" name="description" className="form-control" placeholder="short description here..." />
                            </InputWrapper>

                            <InputWrapper col={5} label="Image (1:1)">
                                <input type="file" className="form-control" onChange={onUserImgUploaded} />
                            </InputWrapper>
                            <div className="col-md-7"></div>
                            <div className="col-md-2">
                                {userImg && <img src={userImg} alt="" className="img-fluid" />}
                            </div>
                            <div className="col-12 mt-4"><h5> Social Links: </h5></div>
                            <InputWrapper col={6} label="Facebook">
                                <input {...register("socialLinks.fb")} defaultValue={writerData.socialLinks.fb} type="text" name="socialLinks.fb" className="form-control" />
                            </InputWrapper>
                            <InputWrapper col={6} label="LinkedIn">
                                <input {...register("socialLinks.linkedIn")} defaultValue={writerData.socialLinks.linkedIn} type="text" name="socialLinks.linkedIn" className="form-control" />
                            </InputWrapper>
                            <InputWrapper col={6} label="Twitter: ">
                                <input {...register("socialLinks.twitter")} defaultValue={writerData.socialLinks.twitter} type="text" name="socialLinks.twitter" className="form-control" />
                            </InputWrapper>
                            <InputWrapper col={6} label="Email: ">
                                <input {...register("socialLinks.email")} defaultValue={writerData.socialLinks.email} type="text" name="socialLinks.email" className="form-control" />
                            </InputWrapper>

                            <div className="col-12 text-center">
                                <Button type="submit">Update Writer's Info</Button>
                            </div>
                        </Row>

                    </form>}
                </div>
            </section>
        </>
    );
};

export default EditWriter;

const InputWrapper = (props) => {
    return (
        <div
            className={
                "input-group mb-3 col-md-" + props.col + " " + props.addClass
            }
        >
            <div className="input-group-prepend">
                <span className="input-group-text">{props.label} </span>
            </div>
            {props.children}
        </div>
    );
};